(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector/assets/javascripts/internal/account-selector.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector/assets/javascripts/internal/account-selector.js');

'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _svs$utils$url = svs.utils.url,
  refreshQueryString = _svs$utils$url.refreshQueryString,
  currentPathEncodedParams = _svs$utils$url.currentPathEncodedParams,
  updateQueryStringParameter = _svs$utils$url.updateQueryStringParameter;
const currencyFromJupiterString = svs.utils.format.CurrencyFromJupiterString;
const logger = new svs.core.log.Logger('numbergames:account_selector');
const drawgamesApiCaller = svs.tur.apiCaller.drawgames;
const AccountSelectorError = svs.numbergames.accountSelector.AccountSelectorError;
const _svs$numbergames$acco = svs.numbergames.accountSelector.constants,
  _svs$numbergames$acco2 = _svs$numbergames$acco.events,
  FETCHED = _svs$numbergames$acco2.FETCHED,
  ACTIVE_ACCOUNT_CHANGED = _svs$numbergames$acco2.ACTIVE_ACCOUNT_CHANGED,
  ACCOUNT_BALANCE_UPDATED = _svs$numbergames$acco2.ACCOUNT_BALANCE_UPDATED,
  _svs$numbergames$acco3 = _svs$numbergames$acco.errors,
  INVALID_ARGUMENTS = _svs$numbergames$acco3.INVALID_ARGUMENTS,
  INVALID_ACCOUNT_SELECTED = _svs$numbergames$acco3.INVALID_ACCOUNT_SELECTED,
  UNKNOWN = _svs$numbergames$acco3.UNKNOWN,
  errorMessages = _svs$numbergames$acco.errorMessages;
const PARAM_NAME = 'syndicateId';
const SPELKONTO_ID = 'SPELKONTO';
class AccountSelector {
  constructor() {
    _defineProperty(this, "playerAccount", null);
    _defineProperty(this, "syndicates", null);
    _defineProperty(this, "accountBalanceUpdateListener", null);
    _defineProperty(this, "selectedAccountIndex", 0);
  }
  listenTo(listeners, context) {
    Object.keys(listeners).forEach(key => {
      this.on(key, listeners[key], context);
    });
  }
  stopListeningTo(listeners) {
    Object.keys(listeners).forEach(key => {
      this.off(key, listeners[key]);
    });
  }
  listenForAccountBalanceComponentUpdates() {
    if (!this.accountBalanceUpdateListener) {
      this.accountBalanceUpdateListener = balance => {
        try {
          this.updateAccountBalance({
            accountId: SPELKONTO_ID,
            balance
          });
        } catch (error) {
          logger.error("Got updated account balance from account_balance component but could not update, new balance was: ".concat(balance), error);
        }
      };
      svs.components.account_balance.on('change', this.accountBalanceUpdateListener);
    }
  }
  fetchPlayerAccount() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      refetch = _ref.refetch;
    if (!refetch && this.fetchAccountPromise) {
      return this.fetchAccountPromise;
    }
    this.fetchAccountPromise = new Promise(resolve => {
      svs.components.account_balance.get(balance => {
        this.playerAccount = [{
          id: SPELKONTO_ID,
          name: 'Mitt saldo',
          balance: currencyFromJupiterString(balance),
          isSyndicate: false
        }];
        this.listenForAccountBalanceComponentUpdates();
        resolve(this.playerAccount);
      });
    });
    return this.fetchAccountPromise;
  }
  async fetchSyndicates() {
    let _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      refetch = _ref2.refetch;
    if (!refetch && this.fetchSyndicatesPromise) {
      return this.fetchSyndicatesPromise;
    }
    try {
      this.fetchSyndicatesPromise = drawgamesApiCaller.getSocialSyndicates();
      const _await$this$fetchSynd = await this.fetchSyndicatesPromise,
        customerSyndicates = _await$this$fetchSynd.response.customerSyndicates;
      this.syndicates = customerSyndicates.map(_ref3 => {
        let id = _ref3.syndicateId,
          playableAmount = _ref3.playableAmount,
          name = _ref3.syndicateName,
          memberRole = _ref3.memberRole,
          adminManagedWagers = _ref3.adminManagedWagers;
        return {
          id: String(id),
          name,
          balance: currencyFromJupiterString(playableAmount),
          isSyndicate: true,
          isPermissionBlocked: adminManagedWagers && memberRole < 6 
        };
      });
    } catch (err) {
      logger.error('Could not retrieve list of syndicates from api', err);
    }
    return this.fetchSyndicatesPromise;
  }
  async fetch() {
    let _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$refetch = _ref4.refetch,
      refetch = _ref4$refetch === void 0 ? false : _ref4$refetch;
    const defaults = {
      accounts: [],
      selectedAccount: SPELKONTO_ID,
      selectedAccountChanged: false
    };
    if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      let selectedAccountChanged = false;
      try {
        await Promise.all([this.fetchSyndicates({
          refetch
        }), this.fetchPlayerAccount({
          refetch
        })]);
        const accounts = await this.getAccounts();
        const syndicateParam = svs.utils.paramHandler.get({
          key: 'syndicateId'
        }).value;
        if (syndicateParam) {
          const index = accounts.findIndex(_ref5 => {
            let id = _ref5.id;
            return id === syndicateParam;
          });
          if (index >= 0) {
            this.selectedAccountIndex = index;
          } else {
            selectedAccountChanged = true;
            svs.utils.paramHandler.remove({
              key: PARAM_NAME
            });
          }
        }
        const selectedAccount = await this.getActiveAccount();
        const result = {
          accounts,
          selectedAccount: selectedAccount.id,
          selectedAccountChanged
        };
        this.trigger(FETCHED, result);
        if (this.selectedAccountIndex) {
          this.trigger(ACTIVE_ACCOUNT_CHANGED, syndicateParam);
        }
        return result;
      } catch (err) {
        logger.error('Could not retrieve list of syndicates from api', err);
        return defaults;
      }
    }
    return defaults;
  }
  getError(type, message) {
    switch (type) {
      case INVALID_ACCOUNT_SELECTED:
        return new AccountSelectorError({
          type,
          message: message || errorMessages[INVALID_ACCOUNT_SELECTED]
        });
      case INVALID_ARGUMENTS:
        return new AccountSelectorError({
          type,
          message: message || errorMessages[INVALID_ARGUMENTS]
        });
      default:
        return new AccountSelectorError({
          type: UNKNOWN,
          message: message || errorMessages[INVALID_ACCOUNT_SELECTED]
        });
    }
  }
  isInitialized() {
    return this.syndicates && this.playerAccount;
  }
  async getAccounts() {
    if (!this.isInitialized()) {
      await this.fetch();
    }
    return [...this.playerAccount, ...this.syndicates];
  }
  async getActiveAccount() {
    if (!this.isInitialized()) {
      if (svs.utils.url.queryString[PARAM_NAME]) {
        const fetchResult = await this.fetch();
        if (fetchResult.selectedAccountChanged) {
          throw this.getError(INVALID_ACCOUNT_SELECTED);
        }
      } else {
        const accounts = await this.fetchPlayerAccount();
        return accounts[this.selectedAccountIndex];
      }
    }
    const accounts = await this.getAccounts();
    return accounts[this.selectedAccountIndex];
  }
  async usePlayerAccount() {
    return this.setActiveAccount(SPELKONTO_ID);
  }
  async findAccount(accountId) {
    let accounts;
    let index;
    let account;
    if (accountId === SPELKONTO_ID) {
      index = 0;
      account = await this.fetchPlayerAccount();
      account = account[0];
      if (this.isInitialized()) {
        accounts = await this.getAccounts();
      }
    } else {
      accounts = await this.getAccounts();
      index = accounts.findIndex(_ref6 => {
        let id = _ref6.id;
        return id === "".concat(accountId);
      });
      if (index >= 0) {
        account = accounts[index];
      }
    }
    return {
      account,
      accounts,
      index
    };
  }
  async setActiveAccount(accountId) {
    if (accountId === undefined) {
      throw this.getError(INVALID_ARGUMENTS, 'Call to setActiveAccount is missing accountId');
    }
    if (Number.isInteger(accountId)) {
      accountId = "".concat(accountId);
    }
    const _await$this$findAccou = await this.findAccount(accountId),
      account = _await$this$findAccou.account,
      index = _await$this$findAccou.index;
    if (!account) {
      throw this.getError(INVALID_ACCOUNT_SELECTED);
    }
    if (account.isSyndicate) {
      refreshQueryString();
      let targetPath = currentPathEncodedParams();
      targetPath = updateQueryStringParameter(targetPath, PARAM_NAME, accountId);
      window.history.replaceState({}, '', targetPath);
    } else {
      svs.utils.paramHandler.remove({
        key: PARAM_NAME
      });
    }
    this.selectedAccountIndex = index;
    this.trigger(ACTIVE_ACCOUNT_CHANGED, accountId);
    return account;
  }
  async updateAccountBalance() {
    let _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      accountId = _ref7.accountId,
      balance = _ref7.balance;
    if (accountId === undefined || balance === undefined) {
      throw this.getError(INVALID_ARGUMENTS, "Call to setActiveAccount is missing".concat(accountId === undefined ? ' accountId' : '').concat(balance === undefined ? ' balance' : ''));
    }
    if (typeof balance !== 'number') {
      const origialBalance = balance;
      balance = currencyFromJupiterString(balance);
      if (isNaN(balance)) {
        throw this.getError(INVALID_ARGUMENTS, "Cannot update account balance as new balance was not a valid number: ".concat(origialBalance));
      }
    }
    const _await$this$findAccou2 = await this.findAccount(accountId),
      account = _await$this$findAccou2.account,
      accounts = _await$this$findAccou2.accounts;
    if (!account) {
      throw this.getError(INVALID_ACCOUNT_SELECTED);
    }
    if (account.balance !== balance) {
      account.balance = balance;
      this.trigger(ACCOUNT_BALANCE_UPDATED, {
        account,
        accounts
      });
    }
    return account;
  }
}
svs.numbergames.accountSelector._internal.AccountSelector = AccountSelector;

 })(window);